import type { TeamMemberT } from 'components/ShiftsList/components/ShiftCard/TeamsSection/types'
import { groupBy } from 'lodash/fp'
import type { PlannedShiftT } from 'types'

export const getAvatarShifts = (avatar: TeamMemberT): PlannedShiftT[] =>
  Object.values(groupBy('shortDescription', avatar.shifts)).map((shifts) => shifts[0])
